import { render, staticRenderFns } from "./TargetReferences.vue?vue&type=template&id=d448fab4"
import script from "./TargetReferences.vue?vue&type=script&lang=js"
export * from "./TargetReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports